module.exports = __webpack_public_path__ + "static/media/quick-insights-img.f79cc5af.png";